<template>
  <article class="catalog-section">
    <header class="text-block">
      <h1>{{ sectionWithCategories.title }}</h1>
      <p v-if="sectionWithCategories.description">
        {{ sectionWithCategories.description }}
      </p>
    </header>
    <div class="catalog-categories">
      <catalog-category-banner
        class="banner"
        v-for="category in sectionWithCategories.categories"
        v-bind:key="category.alias"
        v-bind:category="category"
        v-bind:link-text="'Посмотреть коллекцию'"
      ></catalog-category-banner>
    </div>
  </article>
</template>

<script>
import CatalogCategoryBanner from '../components/the-content/CatalogCategoryBanner'
import utils from './utils'

export default {
  name: 'CatalogSectionPage',
  components: {CatalogCategoryBanner},
  data () {
    return {
      sectionWithCategories: {}
    }
  },
  metaInfo () {
    return {
      title: this.sectionWithCategories.title,
      titleTemplate: '%s | Купить по самым выгодным ценам',
      meta: utils.getDefaultMetaTags({
        description: this.sectionWithCategories.meta_description,
        path: this.$router.resolve(this.$route).href,
        title: this.sectionWithCategories.title,
        imageUrl: this.imageForMeta
      })
    }
  },
  mounted () {
    this.getSectionWithCategories(this.$route.params.section)
  },
  watch: {
    $route (to, from) {
      this.getSectionWithCategories(this.$route.params.section)
    }
  },
  updated () {
    if (Object.keys(this.sectionWithCategories).length > 0 &&
        window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  computed: {
    imageForMeta: function () {
      return (this.sectionWithCategories.categories)
        ? this.sectionWithCategories.categories[0].head_image : ''
    }
  },
  methods: {
    getSectionWithCategories: function (alias) {
      const apiHost = process.env.API_HOST
      this.$http
        .get(`${apiHost}/api/v1/site-structure/get-section-with-categories/${alias}`)
        .then(response => { this.sectionWithCategories = response.body })
    }
  }
}
</script>

<style scoped lang="scss">
  .catalog-section {
    background-color: $default-background-color;
    @include page-block-vertical-padding();

    & > .text-block {
      @include text-block();
      margin-bottom: 1.5em;
    }
    & > .catalog-categories {
      h2 {
        color: $active-link-color;
      }
      .banner {
        page-break-inside: avoid;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/CatalogSectionPage.vue